<template>
    <div class="bookshelves">
        <bookshelf v-for="(books, i) in shelfs" :key="i" :books="books" :max="shelfColumn" @read="$emit('read', $event)">
        </bookshelf>
    </div>
</template>

<script>
import bookshelf from './bookshelf.vue';

export default {
    components: {
        bookshelf,
    },
    data() {
        return {
            width: 0,
            books: {},
        };
    },
    props: {
        value: {
            default() {
                return [];
            }
        },
        size: {
            default: 100,
        }
    },
    computed: {
        shelfs() {
            let result = [];
            let count = this.shelfCount;
            let keys = Object.keys(this.value);
            for (let i = 0; i < count; ++i) {
                let start = i * this.shelfColumn;
                let end = start + this.shelfColumn;
                let books = {};
                keys.slice(start, end).forEach((key) => {
                    books[key] = this.value[key];
                });
                result.push(books);
            }
            return result;
        },
        shelfCount() {
            let count = this.value.length / this.shelfColumn;
            return count > 8 ? count : 8;
        },
        shelfColumn() {
            return Math.floor((this.width - 60) / this.size);
        }
    },
    mounted() {
        this.width = this.$el.clientWidth;
    },
}
</script>

<style lang="less" scoped>
.bookshelves {
    width: 100%;
    height: 100%;
}
</style>
